import {CompetitionPageMetaDataModel} from "../../../models/competition-page.meta-data.model";
import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";

export class CompetitionOddsPageRouteMetaDataModel extends CompetitionPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITION.odds)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITION.odds)
    }

    return description
  }

  get staticTitle() {
    const staticTitle = (this.websiteTerms[`META_TITLE_COMPETITION_ODDS_${this.competitionId}`] || this.websiteTerms.COMPETITION_ODDS_MD_TITLE).format( {
      COMPETITION_NAME: this.competitionName,
    });

    return staticTitle
  }

  get staticDescription() {
    const staticDescription = (this.websiteTerms[`META_DESCRIPTION_COMPETITION_ODDS_${this.competitionId}`] || this.websiteTerms.COMPETITION_ODDS_MD_DESCRIPTION).format({
      "COMPETITION_NAME": this.competitionName,
      "SPORT_TYPE": this.competitionSportName
    });

    return staticDescription;
  }
}